export default __webpack_public_path__ + "static/ibal-e502121d4d9d72c38f741fd79d9cfac2.jpg";